import { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button';

export default function ButtonControl(props) {
	
    function onClick() {
        if (props.onClick)
            props.onClick()
    }	

    return (
		<Button 
			onClick={(e) => onClick()}
			ref={props.inputRef}
			variant={props.variant}
			className={props.className}
			disabled = {props.disabled}
		>
			{props.icon && <i style={{verticalAlign: 'middle', fontSize: '16px'}} class={props.icon}></i>} &nbsp; 
			{props.title}
		</Button>
    )
}